export const windowFeatures =
  "menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes,left=100,top=100,width=500,height=710"

// Initiate service connection through web's #start action. The legacy
// /bulk_channel_activation/new path is only for older mobile apps that hard-code
// it; newer clients (this one included) hit /start directly.
// Same-origin on purpose: an absolute ifttt.com URL opened from another
// subdomain is a universal link on iOS and opens the app instead.
export const buildConnectionPath = (moduleName, liveChannelId, returnTo) => {
  const params = new URLSearchParams()
  if (liveChannelId) params.set("live_channel_id", String(liveChannelId))
  params.set("return_to", returnTo)
  return `/${encodeURIComponent(moduleName)}/activation/start?${params}`
}
